// Physiomobile E-Shop Mock Data

export const categories = [
  { id: 'mobility', name: 'Mobility Aids', icon: 'Move' },
  { id: 'support', name: 'Support & Braces', icon: 'Shield' },
  { id: 'strength', name: 'Strength Training', icon: 'Dumbbell' },
  { id: 'therapy', name: 'Therapy Tools', icon: 'Heart' },
  { id: 'balance', name: 'Balance & Stability', icon: 'Target' },
  { id: 'pain-relief', name: 'Pain Relief', icon: 'Zap' },
];

export const conditions = [
  { id: 'back-pain', name: 'Back Pain', icon: 'Activity' },
  { id: 'knee-pain', name: 'Knee Pain', icon: 'Activity' },
  { id: 'shoulder-pain', name: 'Shoulder Pain', icon: 'Activity' },
  { id: 'stroke-rehab', name: 'Stroke Rehab', icon: 'Brain' },
  { id: 'elderly-mobility', name: 'Elderly Mobility', icon: 'Users' },
  { id: 'post-surgery', name: 'Post-Surgery', icon: 'Stethoscope' },
  { id: 'general-strength', name: 'General Strengthening', icon: 'Dumbbell' },
];

export const bodyParts = [
  { id: 'back', name: 'Back' },
  { id: 'knee', name: 'Knee' },
  { id: 'shoulder', name: 'Shoulder' },
  { id: 'neck', name: 'Neck' },
  { id: 'ankle', name: 'Ankle' },
  { id: 'wrist', name: 'Wrist' },
  { id: 'hip', name: 'Hip' },
  { id: 'full-body', name: 'Full Body' },
];

export const rehabStages = [
  { id: 'acute', name: 'Acute', description: 'Initial recovery phase' },
  { id: 'recovery', name: 'Recovery', description: 'Active rehabilitation' },
  { id: 'maintenance', name: 'Maintenance', description: 'Long-term management' },
];

export const products = [
  {
    id: 'prod-001',
    sku: 'RB-PREM-001',
    name: 'Premium Resistance Band Set',
    shortDescription: 'Progressive strength training for all recovery stages',
    description: 'Professional-grade resistance bands with 5 resistance levels. Perfect for gradual strength building during rehabilitation. Includes door anchor and carrying bag.',
    price: 34.99,
    originalPrice: 44.99,
    cost: 12.50,
    category: 'strength',
    conditions: ['back-pain', 'shoulder-pain', 'post-surgery', 'general-strength'],
    bodyParts: ['back', 'shoulder', 'full-body'],
    rehabStage: ['recovery', 'maintenance'],
    rating: 4.8,
    reviewCount: 324,
    stock: 156,
    images: ['https://images.unsplash.com/photo-1598289431512-b97b0917affc?w=400'],
    badges: ['therapist-recommended', 'best-seller'],
    whyItHelps: 'Resistance bands provide controlled, progressive resistance that strengthens muscles without putting excessive stress on joints. Ideal for rebuilding strength after injury.',
    howToUse: ['Start with the lightest resistance band', 'Perform 10-15 repetitions per exercise', 'Progress to higher resistance as strength improves', 'Use 3-4 times per week'],
    safetyWarnings: ['Stop if you experience sharp pain', 'Not suitable for acute injuries without therapist guidance', 'Check bands for wear before each use'],
    fastShipping: true,
    bundleEligible: true,
  },
  {
    id: 'prod-002',
    sku: 'KB-SUP-002',
    name: 'Compression Knee Brace Pro',
    shortDescription: 'Medical-grade support for knee stability',
    description: 'Advanced compression knee brace with dual stabilizers and adjustable straps. Provides excellent support during recovery from knee injuries or surgery.',
    price: 49.99,
    originalPrice: 59.99,
    cost: 18.00,
    category: 'support',
    conditions: ['knee-pain', 'post-surgery', 'elderly-mobility'],
    bodyParts: ['knee'],
    rehabStage: ['acute', 'recovery', 'maintenance'],
    rating: 4.9,
    reviewCount: 512,
    stock: 89,
    images: ['https://images.unsplash.com/photo-1597452485669-2c7bb5fef90d?w=400'],
    badges: ['therapist-recommended', 'verified'],
    whyItHelps: 'Provides external stability to the knee joint while allowing controlled movement. Reduces swelling through compression and supports weakened ligaments.',
    howToUse: ['Slide brace over knee with patella opening centered', 'Adjust straps for snug but comfortable fit', 'Wear during activity or as directed by therapist'],
    safetyWarnings: ['Do not wear while sleeping unless advised', 'Remove if numbness or increased pain occurs', 'Consult therapist for proper sizing'],
    fastShipping: true,
    bundleEligible: true,
  },
  {
    id: 'prod-003',
    sku: 'PC-POS-003',
    name: 'Posture Corrector Elite',
    shortDescription: 'Ergonomic back alignment support',
    description: 'Lightweight posture corrector designed by physiotherapists. Gently trains muscles for proper alignment without restricting movement.',
    price: 39.99,
    originalPrice: 49.99,
    cost: 14.00,
    category: 'support',
    conditions: ['back-pain', 'shoulder-pain'],
    bodyParts: ['back', 'shoulder'],
    rehabStage: ['recovery', 'maintenance'],
    rating: 4.6,
    reviewCount: 287,
    stock: 203,
    images: ['https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400'],
    badges: ['therapist-recommended'],
    whyItHelps: 'Retrains postural muscles by providing gentle feedback when slouching. Helps prevent chronic back and neck pain from poor posture.',
    howToUse: ['Wear for 30 minutes initially', 'Gradually increase wearing time', 'Use during desk work or daily activities', 'Maximum 2 hours continuous wear'],
    safetyWarnings: ['Do not over-tighten', 'Not for use during sleep', 'Discontinue if skin irritation occurs'],
    fastShipping: true,
    bundleEligible: true,
  },
  {
    id: 'prod-004',
    sku: 'BB-BAL-004',
    name: 'Balance Board Professional',
    shortDescription: 'Core stability and proprioception training',
    description: 'Professional-grade balance board with non-slip surface. Essential for rehabilitation of ankle, knee, and hip injuries. Includes exercise guide.',
    price: 54.99,
    originalPrice: 69.99,
    cost: 22.00,
    category: 'balance',
    conditions: ['knee-pain', 'elderly-mobility', 'post-surgery', 'stroke-rehab'],
    bodyParts: ['ankle', 'knee', 'hip', 'full-body'],
    rehabStage: ['recovery', 'maintenance'],
    rating: 4.7,
    reviewCount: 198,
    stock: 67,
    images: ['https://images.unsplash.com/photo-1518611012118-696072aa579a?w=400'],
    badges: ['best-for-beginners', 'therapist-recommended'],
    whyItHelps: 'Improves proprioception (body awareness) and strengthens stabilizing muscles. Essential for preventing re-injury and improving balance.',
    howToUse: ['Start near a wall or sturdy support', 'Stand with feet hip-width apart', 'Practice maintaining balance for 30-60 seconds', 'Progress to single-leg exercises'],
    safetyWarnings: ['Always use near support initially', 'Not for acute injuries', 'Avoid if you have severe balance disorders without supervision'],
    fastShipping: false,
    bundleEligible: true,
  },
  {
    id: 'prod-005',
    sku: 'FR-THR-005',
    name: 'Foam Roller Deep Tissue',
    shortDescription: 'Self-myofascial release therapy',
    description: 'High-density foam roller with textured surface for effective muscle release. Helps reduce muscle tension, improve flexibility, and speed recovery.',
    price: 29.99,
    originalPrice: 34.99,
    cost: 10.00,
    category: 'therapy',
    conditions: ['back-pain', 'general-strength', 'post-surgery'],
    bodyParts: ['back', 'full-body'],
    rehabStage: ['recovery', 'maintenance'],
    rating: 4.5,
    reviewCount: 445,
    stock: 234,
    images: ['https://images.unsplash.com/photo-1600881333168-2ef49b341f30?w=400'],
    badges: ['best-seller', 'bundle-eligible'],
    whyItHelps: 'Releases myofascial restrictions and trigger points. Improves blood flow to muscles and helps maintain flexibility during recovery.',
    howToUse: ['Place roller under target muscle group', 'Roll slowly back and forth', 'Pause on tender spots for 30-60 seconds', 'Use before and after exercise'],
    safetyWarnings: ['Avoid rolling directly on joints or spine', 'Do not use on acute injuries', 'May cause temporary discomfort'],
    fastShipping: true,
    bundleEligible: true,
  },
  {
    id: 'prod-006',
    sku: 'TN-ELE-006',
    name: 'TENS Pain Relief Device',
    shortDescription: 'Electronic nerve stimulation therapy',
    description: 'FDA-cleared TENS unit with 8 massage modes and adjustable intensity. Provides drug-free pain relief through gentle electrical stimulation.',
    price: 79.99,
    originalPrice: 99.99,
    cost: 35.00,
    category: 'pain-relief',
    conditions: ['back-pain', 'knee-pain', 'shoulder-pain', 'post-surgery'],
    bodyParts: ['back', 'knee', 'shoulder', 'neck', 'full-body'],
    rehabStage: ['acute', 'recovery', 'maintenance'],
    rating: 4.8,
    reviewCount: 623,
    stock: 45,
    images: ['https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400'],
    badges: ['therapist-recommended', 'verified', 'fast-shipping'],
    whyItHelps: 'TENS therapy interrupts pain signals to the brain and stimulates endorphin release. Provides safe, drug-free pain management.',
    howToUse: ['Clean and dry skin before applying pads', 'Place pads around painful area', 'Start at lowest intensity', 'Use for 15-30 minutes per session'],
    safetyWarnings: ['Do not use with pacemaker', 'Avoid use on face, throat, or head', 'Not for use during pregnancy without medical advice'],
    fastShipping: true,
    bundleEligible: false,
  },
  {
    id: 'prod-007',
    sku: 'WA-MOB-007',
    name: 'Adjustable Walking Cane',
    shortDescription: 'Ergonomic mobility support',
    description: 'Lightweight aluminum cane with ergonomic handle and shock-absorbing tip. Adjustable height fits users from 5\'2" to 6\'4".',
    price: 32.99,
    originalPrice: 39.99,
    cost: 12.00,
    category: 'mobility',
    conditions: ['elderly-mobility', 'post-surgery', 'stroke-rehab'],
    bodyParts: ['hip', 'knee', 'ankle'],
    rehabStage: ['acute', 'recovery'],
    rating: 4.6,
    reviewCount: 189,
    stock: 78,
    images: ['https://images.unsplash.com/photo-1584515933487-779824d29309?w=400'],
    badges: ['fast-shipping'],
    whyItHelps: 'Reduces weight bearing on injured or weak legs. Provides stability and confidence during walking rehabilitation.',
    howToUse: ['Adjust height so handle is at wrist level', 'Hold in hand opposite to weak side', 'Move cane forward with affected leg', 'Maintain proper posture while walking'],
    safetyWarnings: ['Ensure tip is in good condition', 'Avoid wet or slippery surfaces', 'Use on flat surfaces initially'],
    fastShipping: true,
    bundleEligible: false,
  },
  {
    id: 'prod-008',
    sku: 'GS-STR-008',
    name: 'Grip Strength Trainer Set',
    shortDescription: 'Progressive hand and forearm strengthening',
    description: 'Set of 4 grip strengtheners with varying resistance (30-100 lbs). Perfect for hand rehabilitation and wrist strength development.',
    price: 24.99,
    originalPrice: 29.99,
    cost: 8.00,
    category: 'strength',
    conditions: ['stroke-rehab', 'post-surgery'],
    bodyParts: ['wrist'],
    rehabStage: ['recovery', 'maintenance'],
    rating: 4.4,
    reviewCount: 156,
    stock: 312,
    images: ['https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400'],
    badges: ['best-for-beginners', 'bundle-eligible'],
    whyItHelps: 'Rebuilds grip strength and dexterity after hand or wrist injury. Improves blood flow and reduces stiffness in fingers and forearm.',
    howToUse: ['Start with lightest resistance', 'Squeeze and hold for 3-5 seconds', 'Perform 10-15 repetitions', 'Progress to higher resistance gradually'],
    safetyWarnings: ['Stop if pain increases', 'Not for use during acute hand injuries', 'Allow rest days between sessions'],
    fastShipping: true,
    bundleEligible: true,
  },
  {
    id: 'prod-009',
    sku: 'OI-SUP-009',
    name: 'Orthotic Insoles Premium',
    shortDescription: 'Arch support and alignment correction',
    description: 'Medical-grade orthotic insoles with arch support and heel cushioning. Helps correct alignment and reduce foot, knee, and back pain.',
    price: 44.99,
    originalPrice: 54.99,
    cost: 16.00,
    category: 'support',
    conditions: ['back-pain', 'knee-pain', 'elderly-mobility'],
    bodyParts: ['ankle', 'knee', 'back'],
    rehabStage: ['maintenance'],
    rating: 4.7,
    reviewCount: 267,
    stock: 145,
    images: ['https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=400'],
    badges: ['verified', 'therapist-recommended'],
    whyItHelps: 'Corrects biomechanical imbalances that contribute to pain. Provides cushioning and support for prolonged standing or walking.',
    howToUse: ['Remove existing insoles from shoes', 'Insert orthotic insoles', 'Wear for 1-2 hours initially', 'Gradually increase wearing time over 2 weeks'],
    safetyWarnings: ['May require adjustment period', 'Not suitable for all shoe types', 'Consult podiatrist if pain persists'],
    fastShipping: true,
    bundleEligible: true,
  },
  {
    id: 'prod-010',
    sku: 'AS-SUP-010',
    name: 'Ankle Stabilizer Brace',
    shortDescription: 'Compression support with lateral stabilizers',
    description: 'Professional ankle brace with figure-8 strapping system. Provides excellent support for ankle sprains and instability.',
    price: 36.99,
    originalPrice: 44.99,
    cost: 14.00,
    category: 'support',
    conditions: ['post-surgery', 'elderly-mobility'],
    bodyParts: ['ankle'],
    rehabStage: ['acute', 'recovery'],
    rating: 4.6,
    reviewCount: 178,
    stock: 92,
    images: ['https://images.unsplash.com/photo-1581009146145-b5ef050c149a?w=400'],
    badges: ['fast-shipping', 'therapist-recommended'],
    whyItHelps: 'Limits excessive ankle movement while allowing functional mobility. Helps protect healing ligaments and prevents re-injury.',
    howToUse: ['Position ankle at 90 degrees', 'Apply figure-8 strapping snugly', 'Adjust for comfort and support', 'Wear during activity as needed'],
    safetyWarnings: ['Do not apply too tightly', 'Check for swelling or color changes', 'Remove during rest unless directed otherwise'],
    fastShipping: true,
    bundleEligible: true,
  },
];

export const rehabKits = [
  {
    id: 'kit-001',
    name: 'Back Pain Starter Kit',
    description: 'Everything you need to begin your back pain recovery journey',
    targetCondition: 'back-pain',
    targetStage: 'recovery',
    products: ['prod-001', 'prod-003', 'prod-005'],
    originalPrice: 104.97,
    bundlePrice: 84.99,
    savings: 19.98,
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400',
  },
  {
    id: 'kit-002',
    name: 'Knee OA Support Kit',
    description: 'Comprehensive support for knee osteoarthritis management',
    targetCondition: 'knee-pain',
    targetStage: 'maintenance',
    products: ['prod-002', 'prod-004', 'prod-009'],
    originalPrice: 149.97,
    bundlePrice: 119.99,
    savings: 29.98,
    image: 'https://images.unsplash.com/photo-1597452485669-2c7bb5fef90d?w=400',
  },
  {
    id: 'kit-003',
    name: 'Stroke Home Rehab Kit',
    description: 'Essential tools for stroke recovery at home',
    targetCondition: 'stroke-rehab',
    targetStage: 'recovery',
    products: ['prod-001', 'prod-004', 'prod-008'],
    originalPrice: 114.97,
    bundlePrice: 94.99,
    savings: 19.98,
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400',
  },
];

export const orders = [
  {
    id: 'ORD-2024-001',
    customerId: 'cust-001',
    customerName: 'Sarah Johnson',
    customerEmail: 'sarah.j@email.com',
    items: [
      { productId: 'prod-001', name: 'Premium Resistance Band Set', quantity: 1, price: 34.99 },
      { productId: 'prod-005', name: 'Foam Roller Deep Tissue', quantity: 1, price: 29.99 },
    ],
    subtotal: 64.98,
    shipping: 5.99,
    discount: 10.00,
    total: 60.97,
    status: 'delivered',
    paymentStatus: 'paid',
    paymentMethod: 'Credit Card',
    shippingAddress: '123 Recovery Lane, Austin, TX 78701',
    trackingNumber: 'TRK-9876543210',
    createdAt: '2024-07-10T10:30:00Z',
    updatedAt: '2024-07-14T15:45:00Z',
    timeline: [
      { status: 'ordered', date: '2024-07-10T10:30:00Z', note: 'Order placed' },
      { status: 'packed', date: '2024-07-11T09:00:00Z', note: 'Order packed' },
      { status: 'shipped', date: '2024-07-12T14:00:00Z', note: 'Shipped via FedEx' },
      { status: 'delivered', date: '2024-07-14T15:45:00Z', note: 'Delivered to front door' },
    ],
  },
  {
    id: 'ORD-2024-002',
    customerId: 'cust-002',
    customerName: 'Michael Chen',
    customerEmail: 'm.chen@email.com',
    items: [
      { productId: 'prod-002', name: 'Compression Knee Brace Pro', quantity: 2, price: 49.99 },
      { productId: 'prod-006', name: 'TENS Pain Relief Device', quantity: 1, price: 79.99 },
    ],
    subtotal: 179.97,
    shipping: 0,
    discount: 0,
    total: 179.97,
    status: 'shipped',
    paymentStatus: 'paid',
    paymentMethod: 'PayPal',
    shippingAddress: '456 Wellness Ave, San Francisco, CA 94102',
    trackingNumber: 'TRK-1234567890',
    createdAt: '2024-07-12T14:20:00Z',
    updatedAt: '2024-07-13T11:00:00Z',
    timeline: [
      { status: 'ordered', date: '2024-07-12T14:20:00Z', note: 'Order placed' },
      { status: 'packed', date: '2024-07-13T09:00:00Z', note: 'Order packed' },
      { status: 'shipped', date: '2024-07-13T11:00:00Z', note: 'Shipped via UPS' },
    ],
  },
  {
    id: 'ORD-2024-003',
    customerId: 'cust-003',
    customerName: 'Emily Rodriguez',
    customerEmail: 'emily.r@email.com',
    items: [
      { productId: 'prod-003', name: 'Posture Corrector Elite', quantity: 1, price: 39.99 },
    ],
    subtotal: 39.99,
    shipping: 5.99,
    discount: 0,
    total: 45.98,
    status: 'processing',
    paymentStatus: 'paid',
    paymentMethod: 'Credit Card',
    shippingAddress: '789 Health St, Denver, CO 80202',
    trackingNumber: null,
    createdAt: '2024-07-14T09:15:00Z',
    updatedAt: '2024-07-14T09:15:00Z',
    timeline: [
      { status: 'ordered', date: '2024-07-14T09:15:00Z', note: 'Order placed' },
    ],
  },
  {
    id: 'ORD-2024-004',
    customerId: 'cust-004',
    customerName: 'David Kim',
    customerEmail: 'd.kim@email.com',
    items: [
      { productId: 'prod-004', name: 'Balance Board Professional', quantity: 1, price: 54.99 },
      { productId: 'prod-008', name: 'Grip Strength Trainer Set', quantity: 1, price: 24.99 },
      { productId: 'prod-001', name: 'Premium Resistance Band Set', quantity: 1, price: 34.99 },
    ],
    subtotal: 114.97,
    shipping: 0,
    discount: 15.00,
    total: 99.97,
    status: 'packed',
    paymentStatus: 'paid',
    paymentMethod: 'Credit Card',
    shippingAddress: '321 Recovery Rd, Seattle, WA 98101',
    trackingNumber: null,
    createdAt: '2024-07-13T16:45:00Z',
    updatedAt: '2024-07-14T08:30:00Z',
    timeline: [
      { status: 'ordered', date: '2024-07-13T16:45:00Z', note: 'Order placed' },
      { status: 'packed', date: '2024-07-14T08:30:00Z', note: 'Ready for shipping' },
    ],
  },
  {
    id: 'ORD-2024-005',
    customerId: 'cust-005',
    customerName: 'Lisa Thompson',
    customerEmail: 'l.thompson@email.com',
    items: [
      { productId: 'prod-007', name: 'Adjustable Walking Cane', quantity: 1, price: 32.99 },
      { productId: 'prod-010', name: 'Ankle Stabilizer Brace', quantity: 1, price: 36.99 },
    ],
    subtotal: 69.98,
    shipping: 5.99,
    discount: 0,
    total: 75.97,
    status: 'pending',
    paymentStatus: 'pending',
    paymentMethod: 'Bank Transfer',
    shippingAddress: '654 Therapy Blvd, Portland, OR 97201',
    trackingNumber: null,
    createdAt: '2024-07-14T11:00:00Z',
    updatedAt: '2024-07-14T11:00:00Z',
    timeline: [
      { status: 'pending', date: '2024-07-14T11:00:00Z', note: 'Awaiting payment confirmation' },
    ],
  },
];

export const therapistRecommendations = [
  {
    therapistName: 'Dr. Amanda Foster',
    clinic: 'ActiveLife Physiotherapy',
    note: 'Suggested for your next 2 weeks of recovery',
    productIds: ['prod-001', 'prod-005'],
  },
  {
    therapistName: 'Dr. James Wilson',
    clinic: 'Peak Performance Rehab',
    note: 'Essential for your knee rehabilitation program',
    productIds: ['prod-002', 'prod-004'],
  },
];

export const adminStats = {
  gmv: 245678.90,
  gmvGrowth: 12.5,
  ordersToday: 47,
  ordersGrowth: 8.3,
  conversionRate: 3.8,
  conversionGrowth: 0.5,
  avgOrderValue: 89.50,
  aovGrowth: 5.2,
  attachRate: 34.5,
  attachGrowth: 2.1,
  returnRate: 2.3,
  returnGrowth: -0.8,
  stockOutRisk: 5,
};

export const salesByCategory = [
  { name: 'Support & Braces', value: 42000 },
  { name: 'Strength Training', value: 35000 },
  { name: 'Therapy Tools', value: 28000 },
  { name: 'Pain Relief', value: 24000 },
  { name: 'Balance', value: 18000 },
  { name: 'Mobility', value: 15000 },
];

export const salesByCondition = [
  { name: 'Back Pain', value: 52000 },
  { name: 'Knee Pain', value: 45000 },
  { name: 'Post-Surgery', value: 38000 },
  { name: 'Elderly Mobility', value: 28000 },
  { name: 'Stroke Rehab', value: 22000 },
];

export const mockUser = {
  id: 'user-001',
  name: 'John Doe',
  email: 'john.doe@email.com',
  role: 'customer',
  conditions: ['back-pain', 'shoulder-pain'],
  loyaltyPoints: 2450,
  savedAddresses: [
    {
      id: 'addr-001',
      label: 'Home',
      address: '123 Health Street, Suite 100',
      city: 'Austin',
      state: 'TX',
      zip: '78701',
      isDefault: true,
    },
  ],
};

export const mockAdmin = {
  id: 'admin-001',
  name: 'Admin User',
  email: 'admin@physiomobile.com',
  role: 'admin',
};

export const aiGuidanceResponses = {
  'how-it-helps': 'This product is designed specifically for rehabilitation purposes. It provides targeted support or resistance that helps rebuild strength and mobility progressively. Clinical studies show that consistent use during recovery can improve outcomes by 30-40%.',
  'when-to-use': 'Use this product as part of your daily rehabilitation routine. For best results, follow your therapist\'s guidance on frequency and duration. Most patients benefit from 2-3 sessions per day, each lasting 15-20 minutes.',
  'safety-tips': 'Always start with the lowest intensity or resistance level. Stop immediately if you experience sharp pain. This product is intended to complement, not replace, professional medical advice. Consult your healthcare provider before starting any new rehabilitation program.',
};